import React, {useState, useEffect} from 'react';
import propTypes from 'prop-types';
import {theme} from '../../themes/default-theme';
import styled from '@emotion/styled';
import {findIndex, get} from 'lodash';
import { ReactSVG } from 'react-svg';

import Banner from '../../components/multimedia/HeroBannerSmall';
import BannerDealer from '../../components/multimedia/Banner';
import CommunityContainer from './CommunityContainer';
import FeatureContainer from './FeatureContainer';
import NewNavSearch from '../../components/navigation/NewMainNav/newNavSearch';
import Loader from '../../components/ui/Loader';
import FilterContainer from '../Community/FilterContainer';
import getUrlParams from '../../util/getUrlParams';

import NavClose from '../../assets/icons/new_nav_close.svg';

const downSm = '@media (max-width: 939.95px)' // '@media (max-width: 839.95px)';
const upMd = '@media (min-width: 940px)' // '@media (min-width: 840px)';

const SearchHandle = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  transition: all 300ms ease;
  z-index: 99;

  ${theme.breakpoints.down('sm')} {
    top: 0;
    left: 100%;
  }
  ${theme.breakpoints.up('md')} {
    opacity: 0;
    visibllity: hidden;
    display: none;
  }

  ${props => props.active &&`
    ${theme.breakpoints.down('sm')} {
      left: 0%;
    }
    ${theme.breakpoints.up('md')} {
      opacity: 1;
      visibllity: visible;
      display: block;
    }
  `}
`

const SearchContainer = styled.div`
  background: #F2F2F2;
  display: flex;
  flex-direction: column;
  gap: 31px;
  justify-content: center;
  align-items: center;
  padding-top: 93px;
  padding-bottom: 65px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 4;
  width: 100%;

  ${theme.breakpoints.down('sm')} {
    height: 100%;
    justify-content: flex-start;
  }

  > div:nth-child(2) {
    width: 100%;
    max-width: 694px;
    text-align: center;
    padding-left: 20px;
    padding-right: 20px;
  }
`

const SearchBG = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 3;
  background: black;
  opacity: .3;
  top: 0;
  left: 0;

  ${theme.breakpoints.down('sm')} {
    display: none;
  }

  ${theme.breakpoints.up('md')} {
    top: 86px;
  }
`

const SearchNavClose = styled(ReactSVG)`
  position: absolute;
  right: 30%;
  top: 34px;
  cursor: pointer;
  z-index: 115;

  ${theme.breakpoints.down('sm')} {
    right: 22px;
    top: 22px;
  }

  &:hover {
      svg {
          [fill] {
              fill: ${theme.palette.charcoal};
          }
      }
  }
`

const SearchTitle = styled.div`
  color: #0170D4;
  font-size: 24px;
  font-weight: 800;
  text-transform: uppercase;

  ${theme.breakpoints.down('sm')} {
    display: none;
  }
`

const Wrapper = styled.div`
  position: relative;
  ${upMd} {
    // margin-top: 74.15px;
  }
  ${theme.breakpoints.up('md')} {
    margin-top: 87px;
  }

  ${props => props.negativeMargin && `
    ${theme.breakpoints.up('sm')} {
      margin-top: -75px;
    }
    ${theme.breakpoints.up('md')} {
      margin-top: -81px;
    }
  `}
`

const TopWrapper = styled.div`
  padding: 20px 0;

  ${theme.breakpoints.up('md')} {
    padding: 40px 0;

    ${props => props.paddingTop &&`
      padding-top: 80px;
    `}
  }
`

const BottomWrapper = styled.div`
  padding-bottom: 30px;

  ${theme.breakpoints.up('md')} {
    padding-bottom: 60px;

    ${props => props.paddingTop &&`
      padding-top: 60px;
    `}
  }
  ${theme.breakpoints.up('lg')} {
    padding-bottom: 120px;
	}

`

const BorderArticles = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  border-bottom: 1px solid ${theme.palette.middleGrey};
`

const ResultStatsContainer = styled.div`
  width: 100%;
  max-width: 1440px;
  padding-left: 20px;
  padding-right: 20px;
`

const ResultStats = styled.div`
  color: #758094;
  font-size: 16px;
  font-weight: 400;
  line-height: 23px;
  text-align: center;
  margin-top: 60px;
  padding-bottom: 35px;
  margin-bottom: 25px;
  border-bottom: 1px solid #D6D6D6;
  padding-left: 20px;
  padding-right: 20px;
`

const CommunityPage = (props) => {
  props = {
    ...props,
    categoryLocation: typeof props.categoryLocation === "undefined" ? '/community' : props.categoryLocation
  };

  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState(null)
  const [searchArticles, setSearchArticles] = useState(null);
  const [hideSearch, setHideSearch] = useState(false);

  const [heroBanner, setHeroBanner] = useState(props.heroBanner)
  const [articleConversion, setArticleConversion] = useState(props.articleConversion)
  const [buyerConversion, setBuyerConversion] = useState(get(props, 'buyerGuides.buyerArticlesConverted', []))
  const [categories, setCategories] = useState(props.categories)
  const [dealerData, setDealerData] = useState(false);
  const [search, setSearch] = useState(false);

  const featuredArticles = articleConversion ? articleConversion.filter(article => article.featured && article.featured.length > 0) : null;

  useEffect(() => {
  try {
    const component = document.getElementById('staticly-dynamics-component-Community');
    // const properties = component ? component.getAttribute('data-component-properties') : null;
    // const jsonData  = properties ? JSON.parse(properties) : null;
    const jsonData = window.staticly.data && window.staticly.data.Community ? window.staticly.data.Community : null

    if (component && !jsonData) {
      component.remove();
      return
    }
    
    if (jsonData) {
      jsonData.heroBanner && setHeroBanner(jsonData.heroBanner);
      jsonData.articleConversion && setArticleConversion(jsonData.articleConversion);
      jsonData.categories && setCategories(jsonData.categories);
      setDealerData(true);
      component && component.remove();

      window.addEventListener('popstate', setQueryState);
      return () => {
        window && window.removeEventListener('popstate', setQueryState);
      }

    }
  } catch {
    // do nothing
  }
  }, []);

  useEffect(() => {
    const firstProps = {
      ...props
    }

    // Bug with next router not returning search? get(props, 'router.query.search', null)
    const searchSplit = firstProps.router.asPath.split('search=');
    if (searchSplit && searchSplit[1]) {
      // handleCategorySearch(searchSplit[1], false)
      setQuery(searchSplit[1]);
    }
  }, [])

  const setQueryState = () => {
    const params = getUrlParams();
    if (params && params.search) {
      setQuery(params.search);
    } else {
      setQuery(null);
    }
  }

  useEffect(() => {
    if (!query) {
      setSearchArticles(null)
    } else {
      handleCategorySearch(query, false)
    }
  }, [query])

  const updateUrl = (search) => {
    if (search) {
      window.history.pushState({
        search: search
      }, undefined, `${window.location.pathname}?search=${search}`);
    } else {
      window.history.pushState({
      }, undefined, `${window.location.pathname}`);
    }

    setQuery(search);
  }

  const handleCategorySearch = async(string, update) => {
    update !== false && updateUrl(string);
    setLoading(true);
    const q = string.split('+').join(' ');
    const domain = process.env.DEALER_SITE && window.staticly.dealerData.website.indexOf('{{') === -1 ? `${window.staticly.dealerData.website.split('.').join('-')}-index/` : '';
    var articles = [];

    if (!(q === 'newest' || q === 'oldest')) {
      let results = await fetch(`https://search-jayco-com-au-prod2-a6b7vb4pyxngznexxbixw567d4.ap-southeast-2.es.amazonaws.com/${domain}_search?pretty=true&size=100&q=` + q)
      
      results = await results.json();
      const hits = get(results, 'hits.hits', []);

      const filteredHits = hits.filter(item => {
        const index = item._index;

        if (domain && permalink && index.contains(domain) === -1 && item._source.post_type && item._source.post_type == 'article') {
          return true
        } else if (item._source.post_type && item._source.post_type == 'article') {
          return true
        } else {
          return false
        }
      })

      articles = articleConversion.filter(item => {
        if (filteredHits.some(obj => parseInt(obj._id) === item.articleID)) {
          return true
        } else {
          false;
        }
      });
    } else {
      setHideSearch(true);
      articles = articleConversion.sort((a, b) => b.date.localeCompare(a.date));

      if (q === 'oldest') {
        articles = articles.reverse();
      }
    }

    setSearchArticles(articles);
    setLoading(false);
  }

  const searchClick = () => {
    setSearch(!search)
  };

  const handleSearchSubmit = (val) => {
    setSearch(false);
    window.location.href = "/community?search=" + val
      .split(' ').join('+');
  }

  const sortHandle = (e) => {
    window.open(`/community?search=${e.value}`, '_self');
  };

  const hbString = `{{#staticlyDynamic data from="template.data" id="Community"  component="src/containers/Community/index.js"}}{{/staticlyDynamic}}`

  const main_site = !process.env.DEALER_SITE;

  // const region = props.region ? props.region : (props.countryProps && props.countryProps.assignedDomain === 'NZ-dealers' ? 'jayco.co.nz' : 'jayco.com.au')

  if (!main_site && !dealerData) {
    return (
      <div dangerouslySetInnerHTML={{__html: hbString}}>
      </div>
    )
  } else {
    return (
      <Wrapper negativeMargin={heroBanner && process.env.DEALER_SITE ? true : false}>
        <SearchHandle active={search}>
          <SearchContainer>
            <SearchTitle>SEARCH JAYCO COMMUNITY</SearchTitle>
            <NewNavSearch
              onFormSubmit={handleSearchSubmit}
            />
            <SearchNavClose src={NavClose} onClick={searchClick} />
          </SearchContainer>
          <SearchBG onClick={searchClick} />
        </SearchHandle> 
        {heroBanner && !process.env.DEALER_SITE ?
          <Banner
            {...heroBanner[0]}
            priority="high"
          />
        :
          <BannerDealer
            {...heroBanner}
            type="mediumBanner"
          />
        } 

        {loading ?
          <Loader />
        : 
          <>
          {typeof window !== 'undefined' && get(window, 'location.search', '').indexOf('search') !== -1 ?
            <BorderArticles>
              {searchArticles && searchArticles.length > 0 ?
                <>
                  <TopWrapper>
                    {!hideSearch &&
                      <ResultStatsContainer>
                        <ResultStats>We found {searchArticles.length} results for "{query.replaceAll('%20', ' ')}"</ResultStats>
                      </ResultStatsContainer>
                    }
                    <CommunityContainer
                      title={null}
                      articles={searchArticles}
                      searchString={query}
                      query={true}
                    />
                  </TopWrapper>
                </>
                : 
                <>
                  <ResultStats>0 results for "{query}".</ResultStats>
                </>
              }
            </BorderArticles>
          :
            <>
              <FilterContainer
                categories={categories}
                categoryLocation={props.categoryLocation}
                categorySearch={process.env.DEALER_SITE}
                searchClick={searchClick}
                sortClick={sortHandle}
                dealer={process.env.DEALER_SITE ? true : false}
              />
              {featuredArticles && featuredArticles.length > 0 &&
                <TopWrapper paddingTop={process.env.DEALER_SITE ? true : false}>
                  <FeatureContainer
                    title={'Featured'}
                    articles={featuredArticles.slice(0, 5)}
                  />
                </TopWrapper>
              }
              {buyerConversion && buyerConversion.length > 0 &&
                <BottomWrapper>
                  <CommunityContainer
                    title={'BUYING GUIDES'}
                    articles={buyerConversion}
                    communityPage={true}
                  />
                </BottomWrapper>
              }
              {articleConversion && articleConversion.length > 0 &&
                <BottomWrapper paddingTop={process.env.DEALER_SITE ? true : false}>
                  <CommunityContainer
                    title={'EXPLORE JAYCO COMMUNITY'}
                    articles={articleConversion}
                    shallowCommunityPage={true}
                  />
                </BottomWrapper>
              }
            </>
           
            }
          </>
        }

      </Wrapper>
    )
  }
}

CommunityPage.propTypes = {
  categoryLocation: propTypes.string
}

export default CommunityPage;